import React, { useEffect, useState } from "react";
import { useGlobalStates } from "../../../context/GlobalStates";

const LeftText = () => {
	const { isDarkMode, setIsTextArea } = useGlobalStates();
	const [isPaste, setIsPaste] = useState("paste");
	const [isCopy, setIsCopy] = useState("copy");
	const [textArea, setTextArea] = useState("");
	const [isDisableInput, setIsDisableInput] = useState(true);
	const [isSelectOption, setIsSelectOption] = useState("to");
	const [isDecodeValue, setIsDecodeValue] = useState(null);
	const [isRun, setIsRun] = useState("run");

	let isCode = null;

	const decodeMessage = (secretMsg, secret, select) => {
		const alphabet = "abcdefghijklmnopqrstuvwxyz";
		const messageLower = secretMsg?.toLowerCase();
		let secretNumber = Number(secret);
		const result = [];
		const regex = /[^A-Za-z]/g;

		if (select === "to" && messageLower?.length > 0) {
			for (let letter of messageLower) {
				if (letter.match(regex)) {
					result.push(letter);
				} else {
					const letterIndex = alphabet.indexOf(letter);

					const newIndex = (letterIndex + secretNumber) % alphabet.length;
					const decodedLetter =
						alphabet[newIndex < 0 ? newIndex + alphabet.length : newIndex];
					result.push(decodedLetter);
				}
			}

			return result.join("");
		} else if (select === "from" && messageLower?.length > 0) {
			secretNumber *= -1;
			for (let letter of messageLower) {
				if (letter.match(regex)) {
					result.push(letter);
				} else {
					const letterIndex = alphabet.indexOf(letter);

					const newIndex = (letterIndex + secretNumber) % alphabet.length;
					const decodedLetter =
						alphabet[newIndex < 0 ? newIndex + alphabet.length : newIndex];
					result.push(decodedLetter);
				}
			}
			return result.join("");
		}
	};

	// Shu qismida harflar qanday tarzda kiritilgan bo'lsa shunday tarzda return bo'lishi kerak

	const textAreaHandle = (event) => {
		const newValue = event?.target?.value;
		setTextArea(newValue);

		if (textArea?.length > 0) {
			setIsCopy("copy");
		}
	};

	useEffect(() => {
		if (textArea?.length > 0) {
			setIsDisableInput(false);
		}
	}, [textArea, setIsDisableInput]);

	const pasteHandleClick = () => {
		navigator.clipboard
			.readText()
			.then((text) => {
				setTextArea(text);
				setIsPaste("pasted");
				console.log("Clipboard content pasted successfully!");
			})
			.catch((err) => {
				console.log("Failed to read clipboard contents: ", err.message);
				setIsPaste("paste");
			});

		setTimeout(() => {
			setIsPaste("paste");
		}, 2000);
	};

	const copyHandleClick = () => {
		if (textArea?.length > 0) {
			setIsCopy("copied");

			navigator.clipboard
				.writeText(textArea)
				.then(() => {
					console.log("Text is copied!");
				})
				.catch((error) => {
					console.log(
						"An error occurred while copying the text: ",
						error.message
					);
				});
		} else {
			setIsCopy("copy");
			console.log("Type or paste something to copy!");
		}

		setTimeout(() => {
			setIsCopy("copy");
		}, 2000);
	};

	const clearTextArea = () => {
		setIsCopy("copy");
		setTextArea("");
	};

	const inputHandleChange = (event) => {
		const inputValue = event?.target?.value;

		if (inputValue?.length > 0) {
			isCode = inputValue;
		}
	};

	const runHandleClick = () => {
		if (!textArea?.length > 0) {
			alert("Please, fill the text area!");
			return;
		} else if (!isCode) {
			alert("Please, enter number code again!");
			return;
		}

		if (isSelectOption === "to") {
			const secretMsg = decodeMessage(textArea, isCode, "to");
			setIsTextArea(secretMsg);
			setIsDecodeValue(textArea);
		} else if (isSelectOption === "from") {
			console.log(textArea);
			const decodedMessage = decodeMessage(textArea, isCode, "from");
			setIsTextArea(decodedMessage);
		}

		// ------------
		if (isCode > 0) {
			setIsRun("copied");

			navigator.clipboard
				.writeText(isCode)
				.then(() => {
					console.log("Code is copied!");
				})
				.catch((error) => {
					console.log(
						"An error occurred while copying the Code: ",
						error.message
					);
				});
		}

		setTimeout(() => {
			setIsRun("run");
		}, 2000);
	};

	const selectHandleChange = (event) => {
		setIsSelectOption(event?.target?.value);
	};

	return (
		<div className="w-full sm:w-1/2">
			<div className="flex justify-between mb-1">
				<select
					title="change options"
					value={isSelectOption}
					onChange={selectHandleChange}
					className="outline-none cursor-pointer rounded-md bg-[#264653] text-white"
				>
					<option value={"to"}>to secret</option>
					<option value={"from"}>from secret</option>
				</select>

				<div className="overflow-hidden space-x-1">
					<input
						value={isCode}
						onChange={inputHandleChange}
						type="number"
						inputMode="numeric"
						min={"0"}
						max={"99"}
						disabled={isDisableInput}
						className="w-12 md:w-40 cursor-text text-black px-1 outline-none border rounded-md"
					/>

					<button
						title="see results"
						onClick={runHandleClick}
						className=" hover:scale-105 cursor-pointer transition-all duration-300 px-2 rounded-md bg-[#7f4f24] text-white text-center"
					>
						{isRun}
					</button>
				</div>
			</div>
			<textarea
				autoFocus
				className={`${
					isDarkMode ? "bg-[#636B6F]" : ""
				} border-r p-1 outline-none shadow-md border-gray-200 w-full resize-none`}
				rows={"20"}
				placeholder="type here..."
				onChange={textAreaHandle}
				value={textArea}
			/>

			<div className="flex justify-between">
				<div className="space-x-2 overflow-hidden">
					<button
						title="paste text"
						onClick={pasteHandleClick}
						className=" hover:scale-105 transition-all duration-300 px-2 rounded-md bg-slate-600 text-white text-center"
					>
						{isPaste}
					</button>
					<button
						title="copy text"
						onClick={copyHandleClick}
						className=" hover:scale-105 transition-all duration-300 px-2 rounded-md bg-[#354f52] text-white text-center"
					>
						{isCopy}
					</button>
					<button
						title="clear text"
						onClick={clearTextArea}
						className=" hover:scale-105 transition-all duration-300 px-2 rounded-md bg-[#e0e1dd] text-black text-center"
					>
						clear
					</button>
				</div>
			</div>
		</div>
	);
};

export default LeftText;
